import React from "react";
import webScreen from "../assets/images/web_screen.png"
import ConnectWeb3 from "../auth/connectWeb3";

const Web3Dashboard = () => {
  return (<div className="">
    
  <div className="banner-shadow">
    <div className="main-container">
          <hl className="wallets-title text-center d-block">Welcome back!</hl>
          <h1 className="wallets-title mb-12 text-center"><span> Please Login to Generate Payment Links.</span> </h1>
          
         
         
          <div className="wallet-btns dashb-btn mt-24">
         <div className="text-center">
          <ConnectWeb3 hasIcon={true} buttonClassName={"login-filled-btn c-pointer"} IconComponent={<span className="icon lg right-arrow c-pointer"></span>}/>
          </div>
          {/* <AppButton block className="btn-style cancel-btn">Guest mode <span className="icon lg right-arrow c-pointer" /></AppButton> */}
         
          </div>
        <div className="text-center mt-24">
          <img src={webScreen} className="crypto-img" />
        </div>
    </div>
  </div>
  </div>
  );
}



export default Web3Dashboard;
